import * as React from 'react';
import { usePkpass } from '../usePkpass';
import { PkpassFieldsType } from '../../../../types';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
import BackField from './field/preview/BackField';
const useStyles = createUseStyles({
  root: {
    backgroundColor: 'white',
    borderRadius: ({
      theme
    }) => theme.scale * 10,
    paddingLeft: ({
      theme
    }) => theme.scale * 10
  },
  backfields: {
    height: ({
      theme
    }) => theme.scale * (450 - 100),
    overflow: 'auto',
    width: '100%'
  }
});

const BackFields = () => {
  const {
    passStyle,
    pass,
    onFieldDnD
  } = usePkpass();
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  const [dragOver, setDragOver] = React.useState(false);

  const onDragOver = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(true);
  };

  const onDragLeave = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(false);
  };

  const onDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    const droppedIndex = Number(event.dataTransfer.getData('droppedIndex'));
    onFieldDnD(PkpassFieldsType.BackFields, 0, PkpassFieldsType.BackFields, droppedIndex);
    setDragOver(false);
  };

  const fields = pass[passStyle].backFields || [];
  const style = dragOver ? theme.dragOver : {};
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.backfields,
    onDrop: onDrop,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave,
    style: style
  }, fields.map((field, index) => {
    return /*#__PURE__*/React.createElement(BackField, {
      key: field.key,
      fieldsType: PkpassFieldsType.BackFields,
      fieldIndex: index
    });
  })));
};

export default BackFields;
//# sourceMappingURL=BackFields.js.map